import { pdfHeaderTag } from "./pdfTagName";
import type Consumer from "../models/Consumer";
import type { FuseRouteNode } from "./fuseReport";

/** Builds the same consumer tag and room-qualified name for both plan types. */
export function connectionRouteConsumer(consumer: Consumer): FuseRouteNode {
  const roomTag = pdfHeaderTag(consumer.parentRoom);
  const name = [consumer.name, roomTag ? `(${roomTag})` : ""].filter(Boolean).join(" ");
  const room = consumer.parentRoom;
  const location = [roomTag, room?.parentFloor?.nameOfDefaultName, room?.nameOfDefaultName].filter(Boolean).join(", ");
  return { key: `consumer:${consumer.id}`, kind: "consumer", consumerId: consumer.id, label: consumer.tag, name, icon: consumer.image,
    caption: { tag: consumer.tag, name: consumer.name, location } };
}
